import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PasswordResetModal from "../components/PasswordResetModal";

const LoginPage = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_BASE_URL;


    const handleLogin = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError(null);

        try {
            const response = await fetch(`${apiUrl}/auth/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.log(errorData)
                throw new Error(errorData.detail || "Failed to login");
            }

            const data = await response.json();


            localStorage.setItem("token", data.token);
            localStorage.setItem("role", data.role);
            localStorage.setItem("roleDetails", JSON.stringify(data.role_details));
            localStorage.setItem("multiUser", data.multiUser);
            localStorage.setItem("universityId",data.universityId)
            localStorage.setItem("universityName",data.name)
            localStorage.setItem("firstName",data.first_name)
            localStorage.setItem("userId", data.user_id)


            navigate("/dashboard");

        } catch (err) {
            console.error("Error during login:", err);
            setError(err.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="" >
            <form className="login100-form validate-form" onSubmit={handleLogin}>

                <span className="login100-form-title m-l-5 p-b-48">
						 <img align="center" src="/libraries/assets/images/glc_logo.png"/>

					</span>
                <div className="wrap-input100 validate-input" data-validate="Valid email is: a@b.c">
                    <input
                        type="email"
                        className="input100"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <span className="focus-input100" data-placeholder="Email"></span>
                </div>
                <div className="wrap-input100 validate-input" data-validate="Enter password">

                    <input
                        type="password"
                        className="input100"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <span className="focus-input100" data-placeholder="Password"></span>
                </div>


                {error && <p className="text-danger">{error}</p>}
                <div className="container-login100-form-btn">
                    <div className="wrap-login100-form-btn">
                        <div className="login100-form-bgbtn"></div>

                        <button type="submit" className="login100-form-btn" disabled={isSubmitting}>
                            {isSubmitting ? "Logging in..." : "Login"}
                        </button>
                    </div>
                </div>
                <div className="text-right p-t-115">


                    <button className="txt1"
                    onClick={() => setShowForgotPasswordModal(true)}  href="#">
                        Forgot password?
                    </button>
                </div>
            </form>

            {showForgotPasswordModal && (
                <PasswordResetModal onClose={() => setShowForgotPasswordModal(false)}/>
            )}
        </div>
    );
};

export default LoginPage;